import { Home } from "lucide-react";
import { useLocale } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function AuthHeader() {
  const locale = useLocale();
  const isRtl = locale === "ar";
  return (
    <div className="p-6 flex justify-between items-center">
      <Link
        href="/"
        className="group flex items-center gap-2 text-slate-400 hover:text-main transition-colors"
      >
        <Home size={20} />
        <span className="text-sm font-bold uppercase tracking-widest">
          {isRtl ? "الرئيسية" : "Home"}
        </span>
      </Link>

      <Link
        href="/"
        className="relative w-32 h-12 transition-transform hover:scale-105 active:scale-95"
      >
        <Image
          src="/custom-logo.png"
          alt="SNA Logo"
          fill
          className="object-contain"
        />
      </Link>
    </div>
  );
}
